/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file licenceTypes.ts
 * @desc Created on Mon Apr 28 2025 20:28:04
 * @copyright All rights reserved @ Inarix
 */

import { GroupInfoData } from "../users/userTypes";

type Uuid = string;
type NoU<T> = T | null | undefined;

export enum LicenseStatus {
  unactivated = 119, // unused and unbound
  assigned, // bound to a user
  ongoing, // activated and currently used
  emptied, // still active, but empty of credits
  expired, // expired (credits might remain)
}

export enum PackStatus {
  unbound = 124,
  bound = 126,
  active,
  emptied,
  expired,
}

export interface LicenseInstance {
  id: Uuid;
  licenseTemplateId: Uuid;
  statusConstantId: LicenseStatus;
  lastStatusUpdatedAt?: NoU<string>;
  activationDate: string;
  expiryDate: string;
  subscriptionEventId?: NoU<Uuid>;
  ownerOrgId: number;
  ownerGroupId?: NoU<number>;
  availableCredits: number;
  metadata: {
    pendingPastActions?: Record<string, boolean>;
    totalCreditsSinceStart?: number;
    [key: string]: unknown;
  };
}
export interface LicenseTemplate {
  id: Uuid;
  slug: string;
  version: number;
  userFacingNameTextId?: NoU<number>;
  parameters: {
    defaultScenarioCost: number;
    specificScenarioCosts?: Record<string, number>;
    [key: string]: unknown;
  };
}
export interface PackInstance {
  id: Uuid;
  packTemplateId: Uuid;
  statusConstantId: PackStatus;
  lastStatusUpdatedAt?: NoU<string>;
  activationDate: string;
  expiryDate: string;
  subscriptionEventId?: NoU<Uuid>;
  boundToLicenseInstanceId?: NoU<Uuid>;
  ownerOrgId: number;
  ownerGroupId?: NoU<number>;
  initialCredits: number;
};


export type ExtendedLicense = LicenseInstance & {
  licenseTemplate: LicenseTemplate;
  ownerGroup?: GroupInfoData;
  packs: PackInstance[];
}
